import { Space, NormalizedPin } from '@/modules/defines/interface';
import { Dispatch, SetStateAction } from 'react';
import normalizationZoneState from './normalizationZoneState';

interface PinPointProps {
  space: Space | undefined;

  standardCoordData: {
    zone: string;
    coord: number[][];
  }[];
  setPoint: Dispatch<SetStateAction<NormalizedPin | null>>;
  zoomPoint: (x: number, y: number, scale: number) => void;
}

const setPoint = ({ ...props }: PinPointProps) => {
  const { space, standardCoordData, setPoint, zoomPoint } = props;
  if (!space || !space.zone) return;
  const zonesOfSpace = space.zone.split(',');

  const relevantCoords = standardCoordData
    .filter((data) => zonesOfSpace?.map((zone) => zone).includes(data.zone))
    .flatMap((data) => data.coord);

  const zoneState = normalizationZoneState(space.floor, space.type);
  const avgX =
    relevantCoords.reduce((sum, coord) => sum + coord[0], 0) /
    relevantCoords.length;
  const avgY =
    relevantCoords.reduce((sum, coord) => sum + coord[1], 0) /
    relevantCoords.length;
  if (avgX && avgY) {
    setPoint({
      id: Date.now(),
      x: avgX,
      y: avgY,
      space_id: space.id,
      space_title: space.title,
      zoneState: zoneState,
      panorama_id: space.default_pano,
    });

    zoomPoint(avgX, avgY, 1);
  }
};

export default setPoint;
